import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_txn_ext_RowClass} from '../../../dbschema';

export class InventoryTransactionExtensionContainerModel extends BaseContainerModel {
  bl_inv_txn_ext: bl_inv_txn_ext_RowClass = new bl_inv_txn_ext_RowClass();

}




